(function () {
  "use strict";

  function setupCarousel(section) {
    var track = section.querySelector('[data-fc-track]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-fc-slide]'));
    var dotsWrap = section.querySelector('[data-fc-dots]');
    var prevBtn = section.querySelector('[data-fc-prev]');
    var nextBtn = section.querySelector('[data-fc-next]');
    if (!track || !slides.length) return;

    // En çok satan ürün ortada açılsın, geri kalanlar satış sırasına göre
    // sağa-sola dönüşmlü yayılsın (DOM'daki 1,2,3... sıralamasını ortadan-dışa
    // doğru fiziksel olarak yeniden diziyoruz).
    if (section.hasAttribute('data-rank-order') && slides.length > 2) {
      var n = slides.length;
      var centerIdx = Math.floor(n / 2);
      var newOrder = new Array(n);
      newOrder[centerIdx] = slides[0];
      var li = centerIdx - 1;
      var ri = centerIdx + 1;
      var turnRight = true;
      for (var i = 1; i < n; i++) {
        if (turnRight) {
          if (ri <= n - 1) { newOrder[ri] = slides[i]; ri++; }
          else { newOrder[li] = slides[i]; li--; }
        } else {
          if (li >= 0) { newOrder[li] = slides[i]; li--; }
          else { newOrder[ri] = slides[i]; ri++; }
        }
        turnRight = !turnRight;
      }
      var lastChild = track.lastElementChild;
      newOrder.forEach(function (slide) { track.insertBefore(slide, lastChild); });
      slides = newOrder;
    }

    slides.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'dot';
      d.setAttribute('aria-label', 'Ürün ' + (i + 1));
      d.addEventListener('click', function () { goTo(i); });
      dotsWrap.appendChild(d);
    });
    var dots = Array.prototype.slice.call(dotsWrap.children);

    function centerOf(el) {
      var r = el.getBoundingClientRect();
      return r.left + r.width / 2;
    }

    function update() {
      var trackRect = track.getBoundingClientRect();
      var trackCenter = trackRect.left + trackRect.width / 2;
      var closestIdx = 0;
      var closestDist = Infinity;

      slides.forEach(function (slide, i) {
        var dist = Math.abs(centerOf(slide) - trackCenter);
        if (dist < closestDist) { closestDist = dist; closestIdx = i; }

        var norm = Math.min(dist / (trackRect.width / 2.6), 1);
        slide.classList.remove('is-center', 'is-near');
        if (norm < 0.12) slide.classList.add('is-center');
        else if (norm < 0.55) slide.classList.add('is-near');
      });

      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === closestIdx); });
    }

    function currentIndex() {
      var idx = dots.findIndex(function (d) { return d.classList.contains('is-active'); });
      return idx === -1 ? 0 : idx;
    }

    // scrollIntoView'in scroll-snap ile zamanlama sorunları yaşanabildiği
    // için hedef scrollLeft'i kendimiz, o anki gerçek geçometriden
    // hesaplıyoruz — bu sayede seçilen kart her zaman tam ortalanır.
    function scrollLeftFor(slide) {
      var slideRect = slide.getBoundingClientRect();
      var trackRect = track.getBoundingClientRect();
      var slideLeftInTrack = (slideRect.left - trackRect.left) + track.scrollLeft;
      return slideLeftInTrack - (track.clientWidth - slideRect.width) / 2;
    }

    function goTo(i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var target = scrollLeftFor(slides[i]);
      if (instant) track.scrollLeft = target;
      else track.scrollTo({ left: target, behavior: 'smooth' });
    }

    var rafPending = false;
    track.addEventListener('scroll', function () {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () { update(); rafPending = false; });
    }, { passive: true });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1); });

    // Fare ile sürükleyerek gezme (masaüstü)
    var isDown = false, startX = 0, startScroll = 0;
    track.addEventListener('mousedown', function (e) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX;
      startScroll = track.scrollLeft;
    });
    window.addEventListener('mouseup', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });
    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      track.scrollLeft = startScroll - (e.pageX - startX);
    });

    window.addEventListener('resize', function () { update(); });

    goTo(Math.floor(slides.length / 2), true);
    update();
    // Bir sonraki karede yeniden ortala — font/görsel yüklenmesiyle gelişen
    // geç düzen değişikliklerine karşı (ör. resim boyutu oturunca kaymaması için).
    requestAnimationFrame(function () {
      goTo(Math.floor(slides.length / 2), true);
      update();
    });
    setTimeout(function () {
      goTo(Math.floor(slides.length / 2), true);
      update();
    }, 250);
  }

  function init() {
    var sections = document.querySelectorAll('.featured-carousel');
    sections.forEach(function (section) { setupCarousel(section); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
